module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-th.d804abb0.mp4";